<template>
	<div class="bottom-payments-editor">
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="active" @toggling-popup="v => $emit('toggling-popup', v)" >
			<div class="bottom-payments-editor-content" v-if="active">
				<ModalHeader no-new-line :title="getString('multi_payments')" />
				<div class="container-payments">
					<div class="container-payment" v-for="payment in groupedPayments" :key="payment.order_payment_id" :class="{selected: payment.active}">
						<div class="header" @click="clickPayment(payment)">
							<div v-if="payment?.customer_company_id" class="invoice-customer-icon-container centered">
								<div class="badge" @click.stop="emitInvoiceCustomer(payment)" v-html="svgStore.get('iconUser')"></div>
							</div>
							<div class="left-container" :class="{clickable: !!payment.receipt_id}">
								<div class="date">{{ formatDate(payment.date) }}</div>
								<div class="type">{{ getString(payment.type) }}</div>
							</div>
							<div class="right-container">
								<div class="pos-receipt" v-if="payment.type === 'stripe'" v-html="svgStore.get('iconSendReceipt')" @click.stop="receiptManagerPayment = payment.payment_id"></div>
								<div class="amount-section">
									<div v-if="payment.fiscal_request" class="ade" @click.stop="sendReceipt(payment)">
										<div
											 :class="{orange: payment.fiscal_receipt, red: !payment.fiscal_receipt}"
											 class="badge" v-html="svgStore.get('iconAde')"
										></div>
									</div>
									<div class="invoice" v-if="payment.invoice_id">
										<div class="badge orange" v-html="svgStore.get('iconInvoice')"></div>
									</div>
									<div class="amount">{{ currencyStore.readableCurrencyValue(payment.payment_amount+payment.payment_amount_tip) }}</div>
								</div>
								<AppChevronIcon :direction="payment.active ? 'up' : 'down'" />
							</div>
						</div>
						<AppDropdown :collapsed="!payment.active" >
							<div class="divisor"></div>
							<div class="container-single-payments">
								<div v-for="order in payment.orders" :key="order.order_payment_id"  class="container-single-payment">
									<div class="left-part">
										<div class="order-number-day">{{ order.order_payment_id ? getString('order_param', [order.orderNumberDayFormatted]) : getString('other_orders') }}</div>
									</div>
									<div class="right-part">
										<div class="amount">{{ currencyStore.readableCurrencyValue(order.amount) }}</div>
									</div>
								</div>
							</div>
						</AppDropdown>
					</div>
				</div>
			</div>
		</AppBottomSheet>
		<ReceiptManager :active="receiptManagerPayment !== null" :payment-id="receiptManagerPayment" @toggling-popup="toggleReceiptManager" @success="successReceipt" />
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import {useCurrencyStore, useLanguageStore, useNotificationStore, useSvgStore} from "@/shared/stores";
import {useMenuStore, useOrdersStore, useUserStore} from "@/console-new/stores";
import {useCounterStore} from "@/console-new/stores/counter.store";
import {formatDateMMDDHHmm} from "@/shared/helpers/dates";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import ReceiptManager from "@/console-pos/components/ReceiptManager.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let menuStore = useMenuStore();
		let counterStore = useCounterStore();
		const svgStore = useSvgStore();
		const ordersStore = useOrdersStore();
		const currencyStore = useCurrencyStore();
		const notificationStore = useNotificationStore();
		return {languageStore, getString: languageStore.getString, userStore, currencyStore, menuStore, counterStore, svgStore, ordersStore, notificationStore};
	},
	name: "OrderPayments",
	components: {ReceiptManager, AppChevronIcon, AppDropdown, AppBottomSheet, ModalHeader},
	mixins: [WindowWidth],
	emits: ["toggling-popup", "open-user-details"],
	props: {
		active: {
			type: Boolean,
			required: true,
		},
		payments: {
			type: Array,
			required: true,
			validator(value) {
				return value.every(v => v.hasOwnProperty("type") && v.hasOwnProperty("amount") && v.hasOwnProperty("order_payment_id"));
			}
		},
	},
	data() {
		return {
			paymentActiveId: null,
			receiptManagerPayment: null,
		}
	},
	computed: {
		groupedPayments() {
			let payments = {};
			this.payments.forEach(payment => {
				if(!this.userStore.manualCode && payment.type === "manual") {
					return;
				}
				if(!payments.hasOwnProperty(payment.payment_id)) {
					payments[payment.payment_id] = {
						...payment,
						orders: [],
						active: this.paymentActiveId === payment.payment_id,
					}
				}
				payments[payment.payment_id].orders.push({
					order_payment_id: payment.order_payment_id,
					order_id: payment.order_id,
					orderNumberDayFormatted: payment.orderNumberDayFormatted,
					amount: payment.amount,
				});

			});
			let paymentsResult = Object.values(payments);
			paymentsResult.sort((a, b) => b.date - a.date);
			paymentsResult.forEach(payment => {
				let diff = (payment.payment_amount + payment.payment_amount_tip);
				payment.orders.forEach(order => {
					diff -= order.amount;
				});
				if(diff !== 0) {
					payment.orders.push({
						order_payment_id: null,
						order_id: null,
						orderNumberDayFormatted: "",
						amount: diff,
					});
				}
			});
			return paymentsResult;
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
	},
	methods: {
		successReceipt() {
			this.notificationStore.showNotification("generic-success");
		},
		toggleReceiptManager(isOpen) {
			if(!isOpen) {
				this.receiptManagerPayment = null;
			}
		},
		emitInvoiceCustomer(payment) {
			this.$emit("open-user-details", {
				customer_id: Number(payment.customer_company_id),
				type: 'company',
			});
		},
		clickPayment(payment) {
			if(this.paymentActiveId === payment.payment_id) {
				this.paymentActiveId = null;
			} else {
				this.paymentActiveId = payment.payment_id;
			}
		},
		formatDate(date) {
			return formatDateMMDDHHmm(date)
		},
		sendReceipt(payment) {
			if(payment) {
				if(payment.receipt_id) {
					this.ordersStore.sendReceiptData = {
						receipt_id: payment.receipt_id,
						id_encrypted: null,
					}
				} else if(payment.epson_receipt_id) {
					this.ordersStore.sendReceiptEpsonData = {
						epson_receipt_id: payment.epson_receipt_id,
						type: payment.type,
					}
				}
			}
		}
	},
}
</script>

<style scoped lang="scss">
.container-payments {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 10px;

	.container-payment {
		display: flex;
		flex-direction: column;
		background-color: var(--color-bg-primary-2);
		border-radius: 13px;
		width: 100%;
		border: 1px solid transparent;
		transition: border 0.3s ease;

		&.selected {
			border: 1px solid var(--color-primary);
		}
		.header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;
			gap: 20px;
			padding: 10px 20px;
			cursor: pointer;

			.invoice-customer-icon-container {
				display: flex;
				flex-direction: column;
				width: 16px;

				:deep(svg) {
					width: 100%;
					.fill {
						fill: var(--color-primary);
					}
					.stroke {
						stroke: var(--color-primary);
					}
				}
			}
			.left-container {
				display: flex;
				flex-direction: column;
				.date {
					font-size: 16px;
				}
				.type {
					font-size: 14px;
					color: #8c8c8c;
				}
			}

			.right-container {
				display: flex;
				align-items: center;
				gap: 8px;
				margin-left: auto;

				.pos-receipt {
					width: 25px;
					height: 25px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					:deep(svg) {
						width: 18px;
						height: 18px;

						.fill {
							fill: var(--color-primary);
						}
						.stroke {
							stroke: var(--color-primary);
						}
					}
				}

				.amount-section {
					display: flex;
					align-items: center;
					justify-content: space-between;
					background-color: var(--color-bg);
					border-radius: 13px;
					padding: 5px 10px;
					box-shadow: 0 1px 5px 0 $alpha_4 inset;
					min-width: 155px;

					.ade, .invoice {
						margin-right: 5px;
						width: 35px;
						height: 35px;
						display: flex;
						align-items: center;
						justify-content: center;

						.badge {
							display: flex;
							align-items: center;
							justify-content: center;
							border-radius: 50px;
							width: 25px;
							height: 25px;
							padding: 6px;

							:deep(svg) {

								.fill {
									fill: var(--color-bg);
								}

								.stroke {
									stroke: var(--color-bg);
								}
							}

							&.red {
								background-color: #E24B74;
							}

							&.orange {
								background-color: #fd831d;
							}
						}

					}
					.amount {
						font-size: 16px;
						color: var(--color-txt-2);
						font-weight: bold;
					}
				}
			}
		}

		@media (max-width: 420px) {
			.header {
				gap: 10px;
				padding: 10px;
			}
		}

		@media (max-width: 380px) {
			.header {
				gap: 2px;
				padding: 10px 2px;
			}
		}

		:deep(.dropdown-content) {
			padding-top: 0;
		}
		
	}

	.divisor {
		width: 100%;
		height: 1px;
		background-color: $alpha_2;
		margin-top: 0;
		margin-bottom: 10px;
	}

	.container-single-payments {
		display: flex;
		flex-direction: column;
		gap: 10px;

		.container-single-payment {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			padding: 10px 20px;
			background-color: #0752A311;
			border-radius: 13px;
			gap: 20px;

			.right-part {
				margin-left: auto;
			}

			.order-number-day {
				font-size: 16px;
				font-weight: bold;
				color: $primary;
			}
			.amount {
				font-size: 16px;
				font-weight: bold;
			}
		}

	}
}
</style>